// Galeria.jsx — sección "Galería", la campaña en redes.

import React from 'react'
import { fetchGallery } from '../../lib/api.js'

function Galeria({ bootstrap = null }) {
  const [items, setItems] = React.useState([])

  React.useEffect(() => {
    if (bootstrap === undefined) return // esperando el fetch consolidado de App

    if (bootstrap) {
      setItems(Array.isArray(bootstrap.gallery?.items) ? bootstrap.gallery.items : [])
      return
    }

    let cancelled = false
    fetchGallery()
      .then((data) => {
        if (cancelled) return
        setItems(Array.isArray(data?.items) ? data.items : [])
      })
      .catch(() => {
        if (!cancelled) setItems([])
      })
    return () => { cancelled = true }
  }, [bootstrap])

  return (
    <section style={{ borderTop: "1px solid var(--line)" }}>
      <div className="wrap">
        <div className="section-head fade-up" style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end", flexWrap: "wrap" }}>
          <div>
            <div className="eyebrow">#MecanicaParaQuilpue</div>
            <h2 className="h-section" style={{ marginTop: 14 }}>
              La campaña <em>en redes</em>
            </h2>
          </div>
          <a className="btn btn-ghost btn-sm" href="https://www.instagram.com/bomberosquilpue" target="_blank" rel="noopener noreferrer">
            Síguenos en Instagram →
          </a>
        </div>

        <div className="photo-strip">
          {items.length === 0 && (
            <>
              <div className="photo-card" aria-hidden="true" />
              <div className="photo-card" aria-hidden="true" />
              <div className="photo-card" aria-hidden="true" />
            </>
          )}
          {items.map((item) => (
            <a
              key={item.id}
              className="photo-card cover"
              href={item.click_url || 'https://www.instagram.com/bomberosquilpue'}
              target={String(item.click_url || '').startsWith('/') ? undefined : '_blank'}
              rel={String(item.click_url || '').startsWith('/') ? undefined : 'noopener noreferrer'}
              title={item.alt_text || 'Ver publicación'}
            >
              <img src={item.image_url} alt={item.alt_text || 'Pieza de campaña'} loading="lazy" />
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

export { Galeria };
